module.exports = __webpack_public_path__ + "img/step2.3dc4bd0a.jpg";